import { AllocationFragment } from 'generated/resources/graphql'

export const sumAllocationsAmountCents = (allocations: AllocationFragment[]) => {
  return allocations.reduce((acc, allocation) => acc + Number(allocation?.amountCents), 0)
}

export const allocationsOverBudget = (
  budgetLimit: number,
  limitPerEmployeeCents: number,
  numberOfEmployees: number,
  totalAllocatedAmountCents: number
) => {
  return budgetLimit < limitPerEmployeeCents * numberOfEmployees + totalAllocatedAmountCents
}

export const allocationsWithAmountIds = (allocations: AllocationFragment[]) => {
  return allocations
    .filter((allocation) => allocation.amountCents !== null)
    .map((allocation) => allocation.id)
}
